<app-global-setup-monitor></app-global-setup-monitor>
<router-outlet></router-outlet>